import { Helmet } from 'react-helmet-async';
import PropTypes from 'prop-types';
import { brandConfig } from 'src/config/brand';

export const Seo = (props) => {
  const { title } = props;

  const fullTitle = title
    ? title + ' | ' + brandConfig.name
    : brandConfig.name;

  return (
    <Helmet>
      <title>
        {fullTitle}
      </title>
    </Helmet>
  );
};

Seo.propTypes = {
  title: PropTypes.string
};
